<template>
  <pb-drawer :visible.sync="drawer" :title="moduleName" size="480px">
    <!-- Loading -->
    <div
      v-if="loading"
      v-loading="loading"
      :element-loading-text="$t('Gattaran_MSGCenter__PuUe' /** 正在加载中… */)"
      class="loading-more"
      style="margin-top: 60%"
    />
    <Fragment v-else>
      <!-- 有角色 -->
      <Fragment v-if="roleList.length">
        <div class="apply-description">
          {{ $t('Gattaran_Homepage__HleZ' /** 以下角色具备该页面权限： */) }}
        </div>
        <div v-for="item in roleList" :key="item.roleId" class="card">
          <div class="name">{{ item.roleName }} (ID: {{ item.roleId }})</div>
          <div class="content">{{ item.description }}</div>
          <pb-button
            class="button"
            type="primary"
            :disabled="isDisabled(item)"
            @click="toApply(item)"
            >{{ getText(item) }}
          </pb-button>
        </div>
      </Fragment>
      <!-- 无角色 -->
      <Fragment v-else>
        <div class="empty">
          <img :src="require('./assets/empty.svg')" />
          <p>{{ $t('Gattaran_Homepage__dzQv' /** 这个功能还没有关联角色权限 */) }}</p>
        </div>
      </Fragment>
    </Fragment>
  </pb-drawer>
</template>

<script>
import { getApplyRoleList } from '../../pages/overview/service';
import { gtrListenEvents } from '@/micro-app';

export default {
  data() {
    return {
      drawer: false,
      secondary: false,
      loading: false,
      disabled: false,
      roleList: [],
      nodeId: 0,
      moduleName: '',
    };
  },
  mounted() {
    // 监听
    gtrListenEvents.GTR_LISTEN_EVENT_APPLY_ROLE_DEAWER((data) => {
      this.nodeId = data.nodeId || 0;
      this.moduleName = data.moduleName || '';
      this.doGetApplyRoleList();
    });
  },
  methods: {
    doGetApplyRoleList() {
      this.drawer = true;
      this.loading = true;
      getApplyRoleList({ nodeId: this.nodeId }).then((res) => {
        this.roleList = res;
        this.loading = false;
      });
    },
    getText(val) {
      const { isOwn } = val;
      return isOwn
        ? this.$t('Gattaran_Homepage__AmGl' /** 已有权限 */)
        : this.$t('Gattaran_Homepage__XQjL' /** 申请权限 */);
    },
    isDisabled(val) {
      const { isOwn } = val;
      return isOwn ? true : false;
    },
    toApply(val) {
      // 跳转我的申请页默认带上申请角色，bizType区分常规角色和仓储物料角色
      const { roleId, bizType = 'bd' } = val;
      this.$router.push(
        `/gtr_console/authmanage/application/add?roleIds=${roleId}&bizType=${bizType}`,
      );
      this.drawer = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.apply-description {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #8d9099;
  margin: 8px 8px 16px;
}

.card {
  width: 448px;
  background: #ffffff;
  border-radius: 4px;
  padding: 16px;

  &:hover {
    background: #f8f8fa;
    cursor: pointer;
  }

  .name {
    font-family: PingFangSC-Semibold;
    font-size: 14px;
    color: #282b33;
    line-height: 22px;
  }

  .content {
    margin-top: 4px;
    margin-bottom: 16px;
    font-family: PingFangSC-Regular;
    font-size: 12px;
    color: #8d9099;
    line-height: 20px;
  }
}

.empty {
  font-size: 14px;
  color: #8d9099;
  text-align: center;
  padding-top: 50%;
}

.loading-more {
  width: 100%;
  height: 74px;
}
</style>
